// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j3v6","colBig":"styles_colBig__HIx1Q","colSmall":"styles_colSmall__3njGk"};